/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateServiceLevelRequest
 */
export interface CreateServiceLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateServiceLevelRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceLevelRequest
     */
    regularPricingPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceLevelRequest
     */
    strategyPricingPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceLevelRequest
     */
    expensePricingPlanId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceLevelRequest
     */
    profileViewsLimit?: number;
}

/**
 * Check if a given object implements the CreateServiceLevelRequest interface.
 */
export function instanceOfCreateServiceLevelRequest(value: object): value is CreateServiceLevelRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('regularPricingPlanId' in value) || value['regularPricingPlanId'] === undefined) return false;
    if (!('strategyPricingPlanId' in value) || value['strategyPricingPlanId'] === undefined) return false;
    if (!('expensePricingPlanId' in value) || value['expensePricingPlanId'] === undefined) return false;
    return true;
}

export function CreateServiceLevelRequestFromJSON(json: any): CreateServiceLevelRequest {
    return CreateServiceLevelRequestFromJSONTyped(json, false);
}

export function CreateServiceLevelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceLevelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'regularPricingPlanId': json['regularPricingPlanId'],
        'strategyPricingPlanId': json['strategyPricingPlanId'],
        'expensePricingPlanId': json['expensePricingPlanId'],
        'profileViewsLimit': json['profileViewsLimit'] == null ? undefined : json['profileViewsLimit'],
    };
}

export function CreateServiceLevelRequestToJSON(value?: CreateServiceLevelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'regularPricingPlanId': value['regularPricingPlanId'],
        'strategyPricingPlanId': value['strategyPricingPlanId'],
        'expensePricingPlanId': value['expensePricingPlanId'],
        'profileViewsLimit': value['profileViewsLimit'],
    };
}

